module.exports = __webpack_public_path__ + "img/dsci0044.959a7069.jpg";